import React, {useEffect, useMemo, useState} from 'react';
import {useGet} from "../../network/useGet";
import NetworkWrapper from "../NetworkWrapper";
import {Button} from "primereact/button";
import {getInitialFormValues, submit} from "./helpers";
import FormField from "./formFields/FormField";
import {useNotificationContext} from "../../context/NotificationContext";
import {ConfirmDialog} from "primereact/confirmdialog";

function BaseForm(props) {
    const { toast } = useNotificationContext();
    const [formState, setFormState] = useState(false);
    const [formErrors, setFormErrors] = useState({});
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);


    const {isLoading: areDropdownListsLoading, data: dropdownLists, error: dropdownListsError} = useGet(useMemo(() => props.dropdownDataUrls, [props.dropdownDataUrls]));
    const dataUrl = props.dataUrl ? props.dataUrl : props.entryId ?  `${props.entityUrl}/${props.entryId}` : null;
    const { isLoading, data: hubData, error } = useGet(dataUrl);

    const updateFormState = (updateFields) => {
        setFormState({...formState, ...updateFields});
    };

    useEffect(() => {
        setFormErrors({});
        if(props.entryId && !hubData) {
            return;
        }

        setFormState(getInitialFormValues(hubData, props.formFields, props.entryId));
    }, [hubData, props.entryId, props.formFields]);

    const showNotification = () => {
        toast.current.show({severity: 'success', summary: 'Success', detail: 'Data stored successfully'});
    };

    const onSuccess = () => {
        showNotification();
        props.onSuccess();
    };

    const onError = () => {
        toast.current.show({severity: 'error', summary: 'Error', detail: 'There has been an error'});
    };

    return (
        <>
            {props.showForm &&
            <NetworkWrapper isLoading={areDropdownListsLoading} error={dropdownListsError}>
                {(!props.dropdownDataUrls || dropdownLists) &&
                <NetworkWrapper isLoading={isLoading} error={error}>
                    <div className="w-full">
                        {(!props.entryId || hubData) && formState &&
                        <div>
                            <form onSubmit={(e) => e.preventDefault()} action="">
                                <div>
                                    {props.formFields.map(field => (
                                        <FormField
                                            key={field.name}
                                            editMode={!!props.entryId || !!props.dataUrl}
                                            {...field}
                                            value={formState[field.name]}
                                            updateFormState={updateFormState}
                                            options={dropdownLists ? dropdownLists[field.optionsKey] : []}
                                            error={formErrors[field.name]}
                                        />
                                    ))}

                                    {Object.keys(formErrors).length !== 0 &&
                                    <div className="mt-4 text-red-800">
                                        Please fix validation errors marked above
                                    </div>
                                    }

                                    <div className="flex justify-between mt-8">
                                        <Button label="Save"
                                                onClick={props.includeIdInUrlOnUpdate ?
                                                    () => submit(`${props.submitUrl}${props.entryId ? "/" + props.entryId : ""}`,  props.entryId ? "PUT" : "POST", formState, onSuccess, setFormErrors, props.formFields, onError):
                                                    () => submit(props.submitUrl, props.entryId ? "PUT" : "POST", formState, onSuccess, setFormErrors, props.formFields, onError)
                                                }
                                        />

                                        {
                                            props.onDelete && props.entryId &&
                                            <Button icon="pi pi-times" severity='danger'  label="Delete" onClick={() => {setShowDeleteConfirm(true)}} />
                                        }

                                        {props.onClose &&
                                        <Button label="Close" onClick={props.onClose}/>
                                        }
                                    </div>
                                </div>
                            </form>
                            <ConfirmDialog
                                visible={showDeleteConfirm}
                                header="Confirmation"
                                message={`You are about to delete this entry. Are you sure?`}
                                accept={() => {
                                    props.onDelete();
                                }}
                                reject={() => setShowDeleteConfirm(false)}
                            />
                        </div>
                        }
                    </div>
                </NetworkWrapper>
                }
            </NetworkWrapper>
            }
        </>
    );
}

export default BaseForm;